import type { ComponentProps } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getDisplayName, getInitial, type NavUser } from "@/lib/userDisplay";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  user: NavUser;
  size?: ComponentProps<typeof Avatar>["size"];
  className?: string;
}

export function UserAvatar({ user, size, className }: UserAvatarProps) {
  return (
    <Avatar size={size} className={className}>
      <AvatarImage src={user.photoURL || undefined} alt="" />
      <AvatarFallback className="bg-linear-to-br from-primary to-primary/80 font-medium text-primary-foreground">
        {getInitial(user)}
      </AvatarFallback>
    </Avatar>
  );
}

interface UserCardProps {
  user: NavUser;
  className?: string;
}

/** Avatar + név + e-mail blokk (az avatar menü fejléce és a mobil fiók lábléce) */
export function UserCard({ user, className }: UserCardProps) {
  return (
    <div className={cn("flex items-center gap-3", className)}>
      <UserAvatar user={user} size="lg" />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-foreground">{getDisplayName(user)}</p>
        <p className="truncate text-xs text-muted-foreground">{user.email}</p>
      </div>
    </div>
  );
}
